module.exports = __webpack_public_path__ + "assets/svg/Icons/32/dashboard-red-351893.svg";